<template>
    <footer>
        <p>&copy {{ new Date().getFullYear() }} RHWK</p>
    </footer>
</template>